import React, { useEffect, useState } from 'react'
import { Box, Button, InputBase, Modal, Paper } from '@mui/material'
import { APIUrlThree, APIUrlToken, APIUrlTwo, GetUserId } from '../../Utils/Utils';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader/Loader';
import FormControlProfile from '../FormControlProfile/Index';
import ClearIcon from '@mui/icons-material/Clear';
import { toast } from 'react-toastify';
import {
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
} from "@mui/material";
import { Padding } from '@mui/icons-material';
const ProspectRequestModal = ({ requestUpdateRecord,
    setSuccessModel, successModel, setRequestUpdateRecord, profileData, peopleId, strengthData, setSelectedOuterRows }) => {

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const styletwo = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
        Padding: "30px"
    };

    const userId = GetUserId();
    const [loading, setLoading] = useState(false)
    const [industryDropDown, setIndustryDropDown] = useState([])
    const [industryValue, setIndustryValue] = useState("")
    const [updatedAt, setUpdatedAt] = useState("");
    const [primaryOrganization, setPrimaryOrganization] = useState("")
    const [primaryJobTitle, setPrimaryJobTitle] = useState("")
    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [linkedin, setLinkedin] = useState()
    const [JOIStrength, setJOIStrength] = useState("")
    const [initialJOIStrength, setInitialJOIStrength] = useState("");
    const [requestStatus, setRequestStatus] = useState();

    const joiStrengthOptions = [
        { label: "Extra Weak", value: "extra weak", min: 1, max: 14 },
        { label: "Weak", value: "weak", min: 15, max: 28 },
        { label: "Slightly Weak", value: "slightly weak", min: 29, max: 42 },
        { label: "Neutral", value: "neutral", min: 43, max: 56 },
        { label: "Slightly Strong", value: "slightly strong", min: 57, max: 70 },
        { label: "Strong", value: "strong", min: 71, max: 84 },
        { label: "Extra Strong", value: "extra strong", min: 85, max: 100 },
    ];

    const allPathWeightdata = [
        "Extra Strong 85-100",
        "Strong 71-84",
        "Slightly Strong 57-70",
        "Neutral 43-56",
        "Slightly Weak 29-42",
        "Weak 15-28",
        "Extra Weak 1-14",
    ];
    const findCategory = (value) => {
        for (const item of joiStrengthOptions) {

            if (value >= item?.min && value <= item?.max) {
                return item
            }
        }
    }

    useEffect(() => {
        if (profileData) {
            setFirstName(profileData?.first_name)
            setLastName(profileData?.last_name)
            setEmail(profileData?.contact_email || profileData?.email)
            setPhone(profileData?.phone_number || profileData?.phone_no)
            setLinkedin(profileData?.linkedin)
            setPrimaryOrganization(profileData?.primary_organization)
            setPrimaryJobTitle(profileData?.primary_job_title)
            setIndustryValue(profileData?.categories)
            setUpdatedAt(profileData?.updated_at)
            let strength = findCategory(profileData?.strengthData?.strength || strengthData?.strength)
            setJOIStrength(strength?.value)
            setInitialJOIStrength(strength?.value);
        }
    }, [profileData]);


    const GetIndustryData = () => {
        setLoading(true);
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            url: `${APIUrlThree()}/v1/people_filters`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                const data = JSON.parse(e?.request?.response);

                setIndustryDropDown(data?.data?.categories);

            })
            .catch(() => {
                setLoading(false);
            });
    };

    // const CheckDirectConnection = () => {
    //     setLoading(true);

    //     const option = {
    //         method: "GET",
    //         headers: {
    //             "access-control-allow-origin": "*",
    //             "content-type": "application/json",
    //             "X-API-Key": APIUrlToken()
    //         },
    //         url: `${APIUrlTwo()}/v1/check_direct_connection?source_uid=${userId}&source_type=people&target_uid=${peopleId}&target_type=people`,
    //     };
    //     axios(option)
    //         .then((e) => {
    //             setLoading(false);
    //             // const data = JSON.parse(e?.data?.response);
    //             setRequestStatus(e?.data);

    //         })
    //         .catch(() => {
    //             setLoading(false);
    //         });
    // };
    useEffect(() => {
        if (requestUpdateRecord === true) {
            GetIndustryData()
        }
    }, [requestUpdateRecord])







    // useEffect(() => {
    //     if (profileData?.person_id) {
    //         CheckDirectConnection()
    //     }
    // }, [profileData])

    const handleModalTrue = () => {
        setSuccessModel(true)

    }
    const SendtRequestUpdate = () => {

        setLoading(true);
        const isJOIStrengthUpdated = JOIStrength !== initialJOIStrength;

        const data = {
            "user_id": 0,
            "first_name": firstName || "",
            "last_name": lastName || "",
            "person_id": peopleId,
            "user_email": email || "",
            "linkedin": linkedin || "",
            "categories": industryValue || "",
            "phone_no": phone || "",
            "primary_organization": primaryOrganization || "",
            "org_id": profileData?.org_id || "",
            "primary_job_title": primaryJobTitle || "",
            "joi_strength": JOIStrength || "",
            "is_joi_strength_updated": isJOIStrengthUpdated,
            "inserted_date": updatedAt || ""
        };


        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            url: `${APIUrlThree()}/v1/user_update_people`,
            data: JSON.stringify(data),
        };
        axios(option)
            .then((response) => {
                setLoading(false);
                setRequestUpdateRecord(false)
                setSelectedOuterRows([])
                handleModalTrue();
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    // const SendtRequestUpdate = () => {

    //     setLoading(true);
    //     const isJOIStrengthUpdated = JOIStrength !== initialJOIStrength;

    //     const data = {
    //         "id": 0,
    //         "firstname": firstName || "",
    //         "lastname": lastName || "",
    //         "people_id": peopleId,
    //         "email": email || "",
    //         "linkedIn": linkedin || "",
    //         "industry": industryValue || "",
    //         "phone": phone || "",
    //         "organization_name": primaryOrganization || "",
    //         "org_id": profileData?.org_id || "",
    //         "jobtitle": primaryJobTitle || "",
    //         "joi_strength": JOIStrength || "",
    //         "is_joi_strength_updated": isJOIStrengthUpdated
    //     };


    //     const option = {
    //         method: "POST",
    //         headers: {
    //             "access-control-allow-origin": "*",
    //             "content-type": "application/json",
    //             "X-API-Key": APIUrlToken()
    //         },
    //         url: `${APIUrlThree()}/v1/user_update_people`,
    //         data: JSON.stringify(data),
    //     };
    //     axios(option)
    //         .then((response) => {
    //             setLoading(false);
    //             setRequestUpdateRecord(false)
    //             setSelectedOuterRows([])
    //             handleModalTrue();
    //         })
    //         .catch((error) => {
    //             setLoading(false);
    //         });
    // }


    return (
        <>
            {loading ? <Loader /> : null}
            <Modal
                open={requestUpdateRecord}
                onClose={() => { setRequestUpdateRecord(false) }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "50%" }}>
                        <div className="de_pad">
                            <h3>Record Update Request</h3>
                            <p className='de_head'>Simply provide the information you want  updated on the record </p>
                            <div className='country-city-request-model'>
                                {/* First Name Field */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='First Name'
                                        value={firstName}
                                        onChange={(e) => setFirstName(e?.target?.value)}
                                    />
                                </div>

                                {/* Last Name Field */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Last Name'
                                        value={lastName}
                                        onChange={(e) => setLastName(e?.target?.value)}
                                    />
                                </div>
                            </div>
                            <div className='country-city-request-model'>
                                {/* Job Title Field */}
                                <div className='de_input_cont-wdt'>
                                    <label htmlFor="" className="label-floating">
                                        Job Title
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        placeholder='Job Title'
                                        style={{ opacity: 0.5, cursor: "not-allowed" }}
                                        value={primaryJobTitle}
                                        onChange={(e) => setPrimaryJobTitle(e?.target?.value)}
                                    />
                                </div>
                                {/* LinkedIn URL Field */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        LinkedIn URL
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='LinkedIn URL'
                                        value={linkedin}
                                        onChange={(e) => setLinkedin(e?.target?.value)}
                                    />
                                </div>
                            </div>
                            {/* Organization Field */}
                            <div className="de_input_cont">
                                <label htmlFor="" className="label-floating">
                                    Organization
                                </label>
                                <input
                                    type="text"
                                    disabled
                                    style={{ opacity: 0.5, cursor: "not-allowed" }}
                                    placeholder='Organization'
                                    value={primaryOrganization}
                                    onChange={(e) => setPrimaryOrganization(e?.target?.value)}
                                />
                            </div>
                            <div className='country-city-request-model'>
                                {/* Email Field */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        Email
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Email'
                                        value={email}
                                        onChange={(e) => setEmail(e?.target?.value)}
                                    />
                                </div>
                                {/* Phone Field */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        Phone
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Phone'
                                        value={phone}
                                        onChange={(e) => setPhone(e?.target?.value)}
                                    />
                                </div>
                            </div>
                            <div className='country-city-request-model'>
                                {/* Industry/sector */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        Industry/Sector
                                    </label>
                                    <FormControlProfile
                                        value={industryValue}
                                        handleChange={(e) => setIndustryValue(e)}
                                        dataList={industryDropDown}
                                    />
                                </div>
                                {/* JOI Strenght */}
                                {/* <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        JOI Strength
                                    </label>
                                    <FormControlProfile
                                        value={JOIStrength}
                                        handleChange={(e) => setJOIStrength(e)}
                                        dataList={joiStrengthOptions}
                                    />
                                </div> */}
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        JOI Strength
                                    </label>
                                    <FormControl sx={{ m: 1, minWidth: 120 }} className="Limit-people-per-company">
                                        <Select
                                            className="select-dropdown-leads"
                                            value={JOIStrength || ""}
                                            onChange={(e) => setJOIStrength(e.target.value)}
                                            displayEmpty
                                        >
                                            <MenuItem value="" disabled className="heading-placeholder">
                                                <em className="placeholder-heading">Select JOI Strength</em>
                                            </MenuItem>
                                            {joiStrengthOptions.map((item, index) => (
                                                <MenuItem key={index} value={item.value} >
                                                    <ListItemText primary={item.label} className='joi-strenght-select-requpdate' />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </div>
                                {/* <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        JOI Strength
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='JOI strength'
                                        value={JOIStrength}
                                        onChange={(e) => setJOIStrength(e?.target?.value)}
                                    />
                                   
                                </div> */}
                                {/* {requestStatus ?
                                    <div className="de_input_cont-wdt">
                                        <label htmlFor="" className="label-floating">
                                            JOI Strength
                                        </label>
                                        <FormControl sx={{ m: 1, minWidth: 120 }} className="Limit-people-per-company">
                                            <Select
                                                className="select-dropdown-leads"
                                                value={JOIStrength || ""}
                                                onChange={(e) => setJOIStrength(e.target.value)}
                                                displayEmpty
                                            >
                                                <MenuItem value="" disabled className="heading-placeholder">
                                                    <em className="placeholder-heading">Select JOI Strength</em>
                                                </MenuItem>
                                                {joiStrengthOptions.map((item, index) => (
                                                    <MenuItem key={index} value={item.value}>
                                                        <ListItemText primary={item.label} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </div> : 
                                    <div className="de_input_cont-wdt-false">
                                        <label htmlFor="" className="label-floating">
                                            JOI Strength
                                        </label>
                                        <FormControl sx={{ m: 1, minWidth: 120 }} className="Limit-people-per-company"
                                        >
                                            <Select
                                                style={{ opacity: 0.5, cursor: 'not-allowed' }}
                                                className="select-dropdown-leads"
                                                value={JOIStrength || ""}
                                                disabled
                                            >
                                                <MenuItem value="" disabled className="heading-placeholder"
                                                >
                                                    <em className="placeholder-heading">Select JOI Strength</em>
                                                </MenuItem>
                                                {joiStrengthOptions.map((item, index) => (
                                                    <MenuItem key={index} value={item.value}>
                                                        <ListItemText className='text-font-requ' primary={item.label} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </div>} */}

                            </div>

                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className='de_cancel' onClick={() => setRequestUpdateRecord(false)}>Cancel</Button>
                                    <Button className='de_next' onClick={() => SendtRequestUpdate()} >Submit</Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>

            {/* <Modal
                open={successModalOpen}
                onClose={() => setSuccessModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "30%", }}>
                        <div className='de_pad_req-up'>
                            <p className='cross-people-req-model'><ClearIcon onClick={() => setSuccessModalOpen(false)} /></p>
                            <p className='de_head'>Your Record Update request has been successfully submitted. The JOI team will review your request and notify you when the record has been updated.</p>
                        </div>
                    </Box>
                </div>
            </Modal> */}

        </>
    )
}

export default ProspectRequestModal
